import type React from 'react'
import { forwardRef } from 'react'
import { cn } from '../../shared/cn'

export type LinkProps = React.ComponentPropsWithoutRef<'a'> & {
  href: string
}

export const Link = forwardRef(function Link(
  { className, ...props }: LinkProps,
  ref: React.ForwardedRef<HTMLAnchorElement>
) {
  return <a {...props} ref={ref} className={cn('text-contentPrimary', className)} />
})
